import { UntitledIcon } from '@faceup/icons'
import { ulRefreshCw01 } from '@faceup/icons/ulRefreshCw01'
import { twMerge } from '@faceup/ui'
import { Button } from '@faceup/ui-base'
import { useEffect, useState } from 'react'
import { defineMessages, FormattedMessage } from '../TypedIntl'
import { FullScreenLoader } from './FullScreenLoader'

const messages = defineMessages({
  buttonReload: 'FollowUp.RouteError.buttonReload',
})

export const RouterFullScreenLoader = () => {
  const [showButton, setShowButton] = useState<boolean>(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <FullScreenLoader>
      <div
        className={twMerge(
          showButton ? 'opacity-100' : 'opacity-0',
          'transition-opacity absolute mt-32'
        )}
      >
        <Button
          onClick={() => window.location.reload()}
          icon={<UntitledIcon icon={ulRefreshCw01} />}
        >
          <FormattedMessage {...messages.buttonReload} />
        </Button>
      </div>
    </FullScreenLoader>
  )
}
